import { createSelector } from 'reselect';
import get from 'lodash/fp/get';

import { getEdition } from 'selectors/getEdition';

const createGetTranslation = createSelector(
  [
    getEdition,
    get('translations'),
  ],
  (edition, translations) =>
    (field, defaultText) => (
      get(`${field}.${edition}`, translations) ||
        defaultText
    ),
);

export default createGetTranslation;
